export enum ClientStatus {
  Pending = "pending",
  Active = "active",
  Rescinded = "rescinded",
  Suspended = "suspended",
}
